import { toTitleCase } from '../../../../../utils/toTitleCase.js';
import { detectAppChanges } from '../../../lib/detectAppChanges.js';

export const appActionOperation = {
  key: 'operation',
  type: 'app',
  label: 'Operation',
  description: 'What the action is doing to the record type.',
  path: 'actions[id:{{actionId}}].operation',
  shouldRun: ({ changes, actionId }) =>
    detectAppChanges(changes, {
      type: 'action',
      actionId,
      keys: ['', 'name', 'description', 'slug', 'model', 'operation']
    }),
  mapContext: ({ app, action }) => ({
    name: action?.name,
    model: action?.model,
    operation: action?.operation || 'none',
    description: action?.description,
    slug: action?.slug,
    appName: app?.name
  }),
  formatLabel: (value) => toTitleCase(value),
  prompt: 'appActionOperation'
};
